import { render, staticRenderFns } from "./PresenterOverlay.vue?vue&type=template&id=c92138ee&scoped=true"
import script from "./PresenterOverlay.vue?vue&type=script&lang=js"
export * from "./PresenterOverlay.vue?vue&type=script&lang=js"
import style0 from "./PresenterOverlay.vue?vue&type=style&index=0&id=c92138ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92138ee",
  null
  
)

export default component.exports